import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetLeaderboardPayload {
  meetingId: string;
  occurenceId: string;
  puzzleId?: number;
}

export default function useGetLeaderboardApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetLeaderboardPayload> {
  return useMutation<any, unknown, GetLeaderboardPayload>(
    async (payload: GetLeaderboardPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_classroom_leaderboard/',
        payload,
      );
      console.log('get Classroom Leaderboard response ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to get Classroom Leaderboard :', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
